export const fetchTopics = resp => {
  return {
    type: "FETCH_TOPICS",
    payload: resp
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/topic.js